import { getValueOrDefault } from './getvalueOrDefault';

export const getWidgetIdFromUrl = (url?: string) => {
  // assuming dataURLs format: /data/[widgetType]/[widgetId]
  return url?.split('/')[3] || url;
};

export function isValidNumber(value: unknown): boolean {
  return value !== null && value !== '' && !isNaN(Number(value)) && isFinite(Number(value));
}

export const getUserSchema = () => {
  const schema = getValueOrDefault<string>(localStorage.getItem('UserState'), '{}');
  const userSchema = getValueOrDefault<string>(JSON.parse(schema).user?.currentSchema, '');
  return userSchema;
};
